import { UntypedFormGroup, ValidatorFn } from '@angular/forms';

export function stringExclusionFormValidator(fieldToCheck: string, exclusionFields: string[]): ValidatorFn {
	return (group: UntypedFormGroup) => {
		let passes: boolean = true;
		const field: string = group.get(fieldToCheck).value;

		exclusionFields.forEach(val => {
			if (!passes || !val) return;

			const exclusionVal: string = group.get(val).value;

			passes =
				exclusionVal?.length > 2
					? !field.includes(exclusionVal?.replace(/  +/g, ' ').trim().toLowerCase())
					: true;
		});

		return !passes ? { exclusionMatch: true } : null;
	};
}
